import React from "react";
import { twMerge } from "tailwind-merge";

export const InputLayout = (props: {
  label: string;
  name: string;
  mandatory?: boolean;
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div className={twMerge("py-2", props.className)}>
      <label
        htmlFor={props.name}
        className="block text-sm text-gray-600 dark:text-gray-400"
      >
        {props.label}
        {props.mandatory && (
          <span className="ml-1 text-red-600 dark:text-red-400">*</span>
        )}
      </label>
      {props.children}
    </div>
  );
};

export const Input = (props: {
  label: string;
  id: string;
  name: string;
  type: string;
  pattern?: string;
  placeholder: string;
  mandatory?: boolean;
  value?: string;
  handleFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sending: boolean;
  className?: string;
}) => {
  return (
    <InputLayout
      label={props.label}
      mandatory={props.mandatory}
      className={props.className}
      name={props.name}
    >
      {React.createElement(props.type === "textarea" ? "textarea" : "input", {
        id: props.id,
        type: props.type === "textarea" ? undefined : props.type,
        name: props.name,
        placeholder: props.placeholder,
        required: props.mandatory,
        pattern: props.pattern,
        value: props.value,
        onChange: props.handleFormChange,
        disabled: props.sending,
        className: twMerge(
          "w-full bg-gray-50 h-12 shadow-sm rounded-2xl border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 dark:bg-gray-900 dark:border-gray-700 dark:text-gray-100 dark:placeholder-gray-500 py-1 px-3 mt-1 leading-8 transition-colors duration-200 ease-in-out",
          props.type === "textarea" && "min-h-[10rem] leading-6 py-3 -mb-2",
        ),
      })}
    </InputLayout>
  );
};

export const Select = (props: {
  label: string;
  id: string;
  name: string;
  options: { value?: string | number; label: string }[];
  placeholder?: string;
  mandatory?: boolean;
  handleFormChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  sending: boolean;
  className?: string;
}) => {
  return (
    <InputLayout
      label={props.label}
      mandatory={props.mandatory}
      className={props.className}
      name={props.name}
    >
      <select
        id={props.id}
        name={props.name}
        required={props.mandatory}
        onChange={props.handleFormChange}
        disabled={props.sending}
        className={twMerge(
          "w-full bg-gray-50 h-12  shadow-sm rounded-2xl border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 dark:bg-gray-900 dark:border-gray-700 dark:text-gray-100 dark:placeholder-gray-500 py-1 px-3 mt-1 leading-8 transition-colors duration-200 ease-in-out",
        )}
        defaultValue=""
      >
        <option value="" disabled>
          {props.placeholder}
        </option>
        {props.options.map((option) => (
          <option
            key={option.value ?? option.label}
            value={option.value ?? option.label}
          >
            {option.label}
          </option>
        ))}
      </select>
    </InputLayout>
  );
};
